const RatingStar = (props: any) => {
    const numericRating = Number(props.rating)
    const scoreText = Number.isFinite(numericRating)
        ? String(Math.round(numericRating * 100) / 100)
        : ""
    const tooltipText = scoreText ? `Review score: ${scoreText}` : "Review score"

    // The score bug (On Air): a yellow plate, one score rule site-wide
    // (9, 9.5, 9.75). The visible number is hidden from screen readers, which
    // read the labelled text instead.
    return (
        <div className="score-bug h-10 shrink-0" title={tooltipText}>
            <span className="sr-only">{tooltipText}</span>
            <span aria-hidden="true">{ props.popularReviewContents && scoreText ? scoreText : "–" }</span>
        </div>
    )
}

export default RatingStar;
